// Vorys Quiz — 3 soru eşleştirme matrisi
// Q1 kim (kadın/erkek) + Q3 renk (siyah/havana/kahve/siyah_havana) → handle + variant rengi
// Q2 kullanım (spor/gunluk/is/seyahat) → cam variant tahmini
window.VorysQuiz = (function() {

  // 8-row eşleştirme: 2 cinsiyet × 4 renk → ürün handle + variant rengi
  const MATRIX = {
    'erkek-siyah':         { handle: 'vorys-akilli-gozluk-vr101', color: 'Siyah',           name: 'VR101 Rectangle' },
    'erkek-havana':        { handle: 'vorys-akilli-gozluk-vr102', color: 'Havana',          name: 'VR102 Rectangle' },
    'erkek-kahve':         { handle: 'vorys-akilli-gozluk-vr103', color: 'Kahverengi',      name: 'VR103 Round' },
    'erkek-siyah_havana':  { handle: 'vorys-akilli-gozluk-vr104', color: 'Havana Kırçıllı', name: 'VR104 Square' },

    'kadin-siyah':         { handle: 'vorys-akilli-gozluk-vr105', color: 'Siyah',           name: 'VR105 Cateye' },
    'kadin-havana':        { handle: 'vorys-akilli-gozluk-vr105', color: 'Havana',          name: 'VR105 Cateye' },
    'kadin-kahve':         { handle: 'vorys-akilli-gozluk-vr106', color: 'Kahverengi',      name: 'VR106 Cateye' },
    'kadin-siyah_havana':  { handle: 'vorys-akilli-gozluk-vr105', color: 'Havana',          name: 'VR105 Cateye' },
  };

  // Q2 kullanım → cam variant tahmini
  const CAM_FROM_USE = {
    spor:    'Polarize Füme',
    gunluk:  'Polarize Füme',
    arac:    'Polarize Füme',
    is:      'Dinlendirici Cam',
    seyahat: 'Dinlendirici Cam',
  };

  function recommend(answers) {
    const key = (answers.kim || 'erkek') + '-' + (answers.renk || 'siyah');
    const m = MATRIX[key] || MATRIX['erkek-siyah'];
    const cam = CAM_FROM_USE[answers.kullanim] || 'Polarize Füme';
    const quizPath = (answers.kim || '') + '-' + (answers.kullanim || '') + '-' + (answers.renk || '');

    return {
      handle: m.handle,
      name:   m.name,
      color:  m.color,
      cam:    cam,
      quizPath: quizPath,
      queryParams: {
        utm_source:  'quiz',
        utm_medium:  'on_site',
        utm_campaign: 'model_secimi',
        utm_content: quizPath,
        quiz_color:  m.color,
        quiz_cam:    cam,
      },
    };
  }

  return { recommend, MATRIX, CAM_FROM_USE };
})();
